<template>
  <div class="content_box">
    <div class="content_box_inner">
      <div id="ManageTable">
        <div class="headTitle" style="margin-bottom: 20px">
          <img src="@/assets/imgs/icon/icon_home.png" alt />
          首页
        </div>
        <hr style="margin-bottom: 20px" />
        <div class="tableList">
          <el-row style="width: 100%">
            <el-col
              :xs="24"
              :lg="12"
              :style="screenWidth < 1200 ? '' : 'padding-right: 30px'"
            >
              <div class="leftTable half">
                <div class="nowTitle">
                  <h3>累计未上报</h3>
                  &emsp;
                  <span style="color: rgba(85, 132, 255, 1)">{{ total }}</span>
                </div>
                <el-table
                  :data="notLoadList"
                  style="width: 100%"
                  :header-cell-style="{
                    backgroundColor: '#DCDFE6',
                    color: '#000',
                  }"
                  @row-click="jumpNotLoadList"
                  class="buttonText"
                >
                  <el-table-column
                    align="center"
                    prop="reportName"
                    label="报表名称"
                  >
                    <template slot-scope="scope">
                      <a
                        :href="scope.row.url"
                        target="_blank"
                        class="buttonText jumPage"
                        >{{ scope.row.reportName }}</a
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="page"
                    label="张数"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="count"
                    label="催报"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型"
                  ></el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :lg="12"
              :style="
                screenWidth < 1200 ? 'padding-top:20px' : 'padding-left: 30px'
              "
            >
              <div class="rightTable half">
                <div class="nowTitle">
                  <h3>累计未修改</h3>
                  &emsp;
                  <span style="color: rgba(85, 132, 255, 1)">{{ total1 }}</span>
                </div>
                <el-table
                  :data="notReList"
                  style="width: 100%"
                  :header-cell-style="{
                    backgroundColor: '#DCDFE6',
                    color: '#000',
                  }"
                  @row-click="jumpNotRelist"
                >
                  <el-table-column
                    align="center"
                    prop="reportName"
                    label="报表名称"
                  >
                    <template slot-scope="scope">
                      <a
                        :href="scope.row.url"
                        target="_blank"
                        class="buttonText jumPage"
                        >{{ scope.row.reportName }}</a
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="page"
                    label="张数"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型"
                  ></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </div>
        <hr style="margin-top: 20px" />
        <div class="part_2 nowTitle">
          <h3>企业经济情况</h3>
          <el-radio-group
            v-model="timeType"
            style="marginright: 40px; margin-left: 15px"
            align="center"
            @change="typeChange"
          >
            <el-radio label="1">当月</el-radio>
            <el-radio label="0">本年累计</el-radio>
          </el-radio-group>
          <el-date-picker
            :style="screenWidth < 1200 ? '' : 'position: absolute; right: 0'"
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-if="timeType == '1'"
            v-model="nowTime"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
          <el-date-picker
            :style="screenWidth < 1200 ? '' : 'position: absolute; right: 0'"
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-if="timeType == '0'"
            v-model="nowTime1"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange"
            type="month"
            placeholder="选择累计月份"
          ></el-date-picker>
        </div>
        <div class="nowTitle">
          <h3>{{ companyName }}</h3>
          <span>{{ timeStr }}</span>
        </div>
        <el-row style="padding: 10px 0px 20px">
          <el-col
            class="card"
            :xs="12"
            :lg="6"
            v-for="(item, index) in cardList"
            :key="index"
          >
            <div class="num">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </el-col>
        </el-row>
        <hr style="margin-top: 20px" />
        <div class="nowTitle">
          <h3>监测情况</h3>
          <el-radio-group
            v-model="timeType1"
            style="marginright: 40px; margin-left: 15px"
            align="center"
            @change="typeChange1"
          >
            <el-radio label="1">当月</el-radio>
            <el-radio label="0">本年累计</el-radio>
          </el-radio-group>
          <el-date-picker
            :style="screenWidth < 1200 ? '' : 'position: absolute; right: 0'"
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-if="timeType1 == '1'"
            v-model="jcqkTime"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange1"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
          <el-date-picker
            :style="screenWidth < 1200 ? '' : 'position: absolute; right: 0'"
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-if="timeType1 == '0'"
            v-model="jcqkTime1"
            :picker-options="pickerOptions1"
            format="yyyy 年"
            value-format="yyyy"
            @change="timeChange1"
            type="year"
            placeholder="选择年"
          ></el-date-picker>
        </div>
        <div class="cutData">
          <div
            :class="['sinBtn', { current: seeBtn.id == item.id }]"
            v-for="item in seeBtnList"
            :key="item.id"
            @click="changeSeeBtn(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="echarts">
          <div id="seeEcharts"></div>
        </div>
        <hr style="margin-top: 20px" />
        <div class="nowTitle">
          <h3>产品情况</h3>
          <el-radio-group
            v-model="timeType2"
            style="marginright: 40px; margin-left: 15px"
            align="center"
            @change="typeChange2"
          >
            <el-radio label="1">当月</el-radio>
            <el-radio label="0">本年累计</el-radio>
          </el-radio-group>
          <el-date-picker
            :style="screenWidth < 1200 ? '' : 'position: absolute; right: 0'"
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-if="timeType2 == '1'"
            v-model="cpqkTime"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange2"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
          <el-date-picker
            :style="screenWidth < 1200 ? '' : 'position: absolute; right: 0'"
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-if="timeType2 == '0'"
            v-model="cpqkTime1"
            :picker-options="pickerOptions1"
            format="yyyy 年"
            value-format="yyyy"
            @change="timeChange2"
            type="year"
            placeholder="选择年"
          ></el-date-picker>
        </div>
        <div class="cutData">
          <div
            :class="['sinBtn', { current: proBtn.code == item.code }]"
            v-for="item in proBtnList"
            :key="item.code"
            @click="changeProBtn(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="echarts">
          <div id="proEcharts"></div>
        </div>
        <hr style="margin-top: 20px" />
        <h3>企业情况</h3>
        <div class="Content">
          <el-row>
            <el-col :xs="24" :lg="8">
              <img
                style="width: 100%"
                src="@/assets/imgs/image/compangPic.png"
                alt
              />
            </el-col>
            <el-col :xs="24" :lg="16">
              <div class="detail">
                <div
                  class="itemPart"
                  v-for="(item, index) in detailList"
                  :key="index"
                >
                  <div class="name">{{ item.name }}</div>
                  <div class="value">{{ item.value }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { companyIndexSee, companyIndexPro } from "@/utils/echarts_set.js";
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      companyName: "",
      timeStr: "",
      total: "",
      total1: "",
      notLoadList: [],
      notReList: [],
      cardList: [],
      seeBtnList: [
        { name: "工业总产值", id: 0 },
        { name: "工业销售产值", id: 1 },
        { name: "企业用电量", id: 2 },
        { name: "主营业务收入", id: 3 },
        { name: "税收", id: 4 },
        { name: "利润总额", id: 5 },
        { name: "存货", id: 6 },
        { name: "贷款余额", id: 7 },
      ],
      detailList: [],
      proBtnList: [],
      seeBtn: { name: "工业总产值", id: 0 },
      proBtn: {},
      jcqk: "",
      cpqk: "",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      timeType: "1",
      timeType1: "1",
      timeType2: "1",
      nowTime: "",
      nowTime1: "",
      jcqkTime: "",
      jcqkTime1: "",
      cpqkTime: "",
      cpqkTIme1: "",
      timeString: "",
      timeString1: "",
      timeString2: "",
    };
  },
  methods: {
    initPro() {
      this.$axios.get("/business/companyHome//selectProByCode").then((res) => {
        this.proBtnList = res.data;
        this.proBtn = res.data[0];

        this.creatEcharts();
      });
    },

    jumpNotRelist() {
      // alert(1);
      this.$router.push("/index/workbench/dataWrite?activeName=edit");
    },
    jumpNotLoadList() {
      this.$router.push("/index/workbench/dataWrite");
    },
    getNotLoadList(id, type, status) {
      //  console.log(111);
      // var param="id=015d8b761f864eaaa0d6ec7f38705610&type=0&status=0";
      this.$axios
        .get("/business/companyHome/selectReport?type=0&status=0,1,2")
        .then((res) => {
          //   console.log(res.data);
          this.notLoadList = res.data;
          this.total = res.total;
        });
    },
    getNotUpdatedList(id, type, status) {
      //  console.log(111);
      // var param="id=015d8b761f864eaaa0d6ec7f38705610&type=0&status=0";
      this.$axios
        .get("/business/companyHome/selectReport?type=1&status=1,3")
        .then((res) => {
          this.notReList = res.data;
          this.total1 = res.total;
        });
    },
    typeChange: function (val) {
      let that = this;
      //   console.log(val);
      that.timeType = val;
      if (val == "0") {
        var data = new Date();
        var month =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
        var time = data.getFullYear() + "-" + month;
        that.nowTime1 = data;
        that.timeChange(time);
      } else if (val == "1") {
        var data1 = new Date();
        var month1 =
          data1.getMonth() < 9
            ? "0" + (data1.getMonth() + 1)
            : data1.getMonth() + 1;
        var date1 =
          data1.getDate() <= 9 ? "0" + data1.getDate() : data1.getDate();
        var time1 = data1.getFullYear() + "-" + month1;
        that.nowTime = data1;
        that.timeChange(time1);
      }
    },
    typeChange1: function (val) {
      let that = this;
      that.timeType1 = val;
      if (val == "0") {
        var data = new Date();
        var month =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
        var time = data.getFullYear();
        that.jcqkTime1 = data;
        that.timeChange1(time);
      } else if (val == "1") {
        var data1 = new Date();
        var month1 =
          data1.getMonth() < 9
            ? "0" + (data1.getMonth() + 1)
            : data1.getMonth() + 1;
        var date1 =
          data1.getDate() <= 9 ? "0" + data1.getDate() : data1.getDate();
        var time1 = data1.getFullYear() + "-" + month1;
        that.jcqkTime = data1;
        that.timeChange1(time1);
      }
      //          var bt1=   {name:   "工业总产值",id:0};
      //          this.changeSeeBtn(bt1);
    },
    typeChange2: function (val) {
      let that = this;
      that.timeType2 = val;
      // console.log(that.timeType2);

      if (val == "0") {
        var data = new Date();
        var month =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
        var time = data.getFullYear();
        that.cpqkTime1 = data;
        that.timeChange2(time);
      } else if (val == "1") {
        var data1 = new Date();
        var month1 =
          data1.getMonth() < 9
            ? "0" + (data1.getMonth() + 1)
            : data1.getMonth() + 1;
        var date1 =
          data1.getDate() <= 9 ? "0" + data1.getDate() : data1.getDate();
        var time1 = data1.getFullYear() + "-" + month1;
        that.cpqkTime = data1;
        that.timeChange2(time1);
      }
      //      var tb2=   {name:   "铁矿石原矿",id:0} ;
      //      this.changeProBtn(tb2);
    },
    setTime() {
      var data = new Date();
      var month =
        data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var year = data.getFullYear();
      this.nowTime1 = data; //year;
      this.nowTime = data; //year+"-"+month;
      this.jcqkTime = data;
      this.jcqkTime1 = data;
      this.cpqkTime = data;
      this.cpqkTime1 = data;
      var time = year + "-" + month;
      this.timeString1 = time;
      this.timeString2 = time;
      //  console.log(this.nowTime1);

      this.timeChange(time);
    },
    timeChange1(val) {
      var type = this.timeType1;
      var timeCompare = "";
      if (typeof val !== "string") {
        timeCompare = val.toString();
      } else timeCompare = val;
      //  console.log(timeCompare);

      this.timeString1 = timeCompare;
      var bt1 = this.seeBtn;
      this.changeSeeBtn(bt1);
    },
    timeChange2(val) {
      var type = this.timeType2;

      var timeCompare = "";

      if (typeof val !== "string") {
        timeCompare = val.toString();
      } else timeCompare = val;
      console.log(timeCompare);

      this.timeString2 = timeCompare;
      var tb2 = this.proBtn;
      //  alert( this.proBtnList[0]);
      this.changeProBtn(tb2);
    },
    timeChange(val) {
      var type = this.timeType;
      var time = "";
      var nameStr = "";
      var data = new Date();
      var yearNow = data.getFullYear();
      var timeCompare = "";

      if (typeof val !== "string") {
        timeCompare = val.toString();
      } else timeCompare = val;
      //.log(timeCompare);
      var timeArray = timeCompare.split("-");

      var month = data.getMonth() + 1;

      if (type == "0") {
        if (parseInt(timeArray[1]) == 1) {
          time = "1月";
        } else time = "1-" + parseInt(timeArray[1]) + "月";
        //   console.log(month);
      } else if (type == "1") {
        time = parseInt(timeArray[1]) + "月";
      }
      this.timeString = timeCompare;
      this.timeStr = time;

      this.$axios
        .get(
          "/business/companyHome/selectPercent?type=" + type + "&time=" + val
        )
        .then((res) => {
          //   console.log(res.data);
          // this.cardList=[];
          var card = [];

          var obj = {
            num: res.data.value1.toFixed(2),
            label: time + "总产值(万元)",
          };

          var obj2 = {
            label: "占本市全行业（大类）比",
            num: res.data.value3,
          };

          var obj4 = {
            label: "占本市总产值比",
            num: res.data.value5,
          };

          var obj6 = {
            label: "占本区（县）总产值比",
            num: res.data.value7,
          };

          if (type == "0") {
            card.push(obj);
            card.push(obj2);
            card.push(obj4);
            card.push(obj6);
          } else if (type == "1") {
            card.push(obj);
            card.push(obj2);
            card.push(obj4);
            card.push(obj6);
          }
          console.log(card);
          this.cardList = card;
        });
    },
    changeSeeBtn(now) {
      this.seeBtn = now;
      var dataArray = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      var timeArray = [];
      var type = this.timeType1;
      if (type == "0") {
        timeArray = [
          "1月",
          "1-2月",
          "1-3月",
          "1-4月",
          "1-5月",
          "1-6月",
          "1-7月",
          "1-8月",
          "1-9月",
          "1-10月",
          "1-11月",
          "1-12月",
        ];
      } else if (type == "1") {
        timeArray = [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ];
      }

      var speedArray = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      this.seeBtn = now;
      this.jcqk = now.name;
      console.log(now);
      //var data = new Date();
      //var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      //var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var time = this.timeString1; //data.getFullYear();
      this.$axios
        .get(
          "/business/companyHome/selectCondition?time=" + time + "&type=" + type
        )
        .then((res) => {
          var dataObj = [];
          if (now.id == 0) {
            dataObj = res.data.gyzcz;
            for (var i = 0; i < dataArray.length; i++) {
              for (var j = 0; j < dataObj.length; j++) {
                if (dataObj[j].monthQuery == i + 1) {
                  dataArray[i] = dataObj[j].monthThis1.toFixed(2);
                  speedArray[i] = dataObj[j].monthThis.toFixed(1);
                }
              }
            }
          }
          if (now.id == 1) {
            dataObj = res.data.gyxscz;
            for (var i1 = 0; i1 < dataArray.length; i1++) {
              for (var j1 = 0; j1 < dataObj.length; j1++) {
                if (dataObj[j1].monthQuery == i1 + 1) {
                  dataArray[i1] = dataObj[j1].monthThis1.toFixed(2);
                  speedArray[i1] = dataObj[j1].monthThis.toFixed(1);
                }
              }
            }
          }
          if (now.id == 2) {
            dataObj = res.data.qyydl;
            for (var i2 = 0; i2 < dataArray.length; i2++) {
              for (var j2 = 0; j2 < dataObj.length; j2++) {
                if (dataObj[j2].monthQuery == i2 + 1) {
                  dataArray[i2] = dataObj[j2].monthThis1.toFixed(2);
                  speedArray[i2] = dataObj[j2].monthThis.toFixed(1);
                }
              }
            }
          }
          if (now.id == 3) {
            dataObj = res.data.zyywsr;
            for (var i3 = 0; i3 < dataArray.length; i3++) {
              for (var j3 = 0; j3 < dataObj.length; j3++) {
                if (dataObj[j3].monthQuery == i3 + 1) {
                  dataArray[i3] = dataObj[j3].thisMonth.toFixed(2);
                  speedArray[i3] = parseFloat(dataObj[j3].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 4) {
            dataObj = res.data.sj;
            for (var i4 = 0; i4 < dataArray.length; i4++) {
              for (var j4 = 0; j4 < dataObj.length; j4++) {
                if (dataObj[j4].monthQuery == i4 + 1) {
                  dataArray[i4] = dataObj[j4].thisMonth.toFixed(2);
                  speedArray[i4] = parseFloat(dataObj[j4].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 5) {
            dataObj = res.data.lrze;
            for (var i5 = 0; i5 < dataArray.length; i5++) {
              for (var j5 = 0; j5 < dataObj.length; j5++) {
                if (dataObj[j5].monthQuery == i5 + 1) {
                  dataArray[i5] = dataObj[j5].thisMonth.toFixed(2);
                  speedArray[i5] = parseFloat(dataObj[j5].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 6) {
            dataObj = res.data.ch;
            for (var i6 = 0; i6 < dataArray.length; i6++) {
              for (var j6 = 0; j6 < dataObj.length; j6++) {
                if (dataObj[j6].monthQuery == i6 + 1) {
                  dataArray[i6] = dataObj[j6].thisMonth.toFixed(2);
                  speedArray[i6] = parseFloat(dataObj[j6].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 7) {
            dataObj = res.data.dkye;
            for (var i7 = 0; i7 < dataArray.length; i7++) {
              for (var j7 = 0; j7 < dataObj.length; j7++) {
                if (dataObj[j7].monthQuery == i7 + 1) {
                  dataArray[i7] = dataObj[j7].thisMonth.toFixed(2);
                  speedArray[i7] = parseFloat(dataObj[j7].code).toFixed(1);
                }
              }
            }
          }
          var minInNumbers = Math.min.apply(Math, speedArray);
          var maxInNumbers = Math.max.apply(Math, dataArray);
          var max = 0;
          var min = 0;
          if (maxInNumbers > 250) max = maxInNumbers + 100;
          else max = 250;
          max = Math.ceil(max);
          if (minInNumbers < 0) min = -100;
          else min = 0;
          var gird = Math.ceil(max / 10);
          let _this = this;
          //监测情况
          var seeEcharts = _this.$echarts.init(
            document.getElementById("seeEcharts")
          );
          var legendData = [];
          if (type == "0") {
            legendData = ["本年累计", "同比增速"];
          } else if (type == "1") {
            legendData = ["本月", "同比增速"];
          }
          seeEcharts.setOption(
            companyIndexSee({
              xAxis: timeArray,
              currentYear: dataArray,
              speed: speedArray,
              legend: legendData,
              min: min,
              max: max,
              gird: gird,
              title: this.jcqk,
            })
          );
        });
    },
    changeProBtn(now) {
      this.proBtn = now;
      this.cpqk = now.name;
      console.log(now);
      var code = now.code;
      var timeArray = [];
      var type = this.timeType2;
      if (type == "0") {
        timeArray = [
          "1月",
          "1-2月",
          "1-3月",
          "1-4月",
          "1-5月",
          "1-6月",
          "1-7月",
          "1-8月",
          "1-9月",
          "1-10月",
          "1-11月",
          "1-12月",
        ];
      } else if (type == "1") {
        timeArray = [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ];
      }
      var thisData = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      var thatData = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      var speedData = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      //var data = new Date();
      //var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      //var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var time = this.timeString2; //data.getFullYear();data.getFullYear();
      this.$axios
        .get(
          "/business/companyHome/selectProduct?time=" +
            time +
            "&type=" +
            type +
            "&code=" +
            code
        )
        .then((res) => {
          var dataObj = [];
          dataObj = res.data;
          for (var m = 0; m < thisData.length; m++) {
            for (var n = 0; n < dataObj.length; n++) {
              if (dataObj[n].monthQuery == m + 1) {
                thisData[m] = dataObj[n].monthLast.toFixed(2);
                thatData[m] = dataObj[n].monthThis.toFixed(2);
                speedData[m] = dataObj[n].monthThis1.toFixed(1);
              }
            }
          }
          if (now.id == 0) {
            dataObj = res.data.tksyk;
            for (var i = 0; i < thisData.length; i++) {
              for (var j = 0; j < dataObj.length; j++) {
                if (dataObj[j].monthQuery == i) {
                  thisData[i] = dataObj[j].monthLast;
                  thatData[i] = dataObj[j].monthThis;
                  speedData[i] = dataObj[j].monthThis1;
                }
              }
            }
          }
          if (now.id == 1) {
            dataObj = res.data.tkscpk;
            for (var i1 = 0; i1 < thisData.length; i1++) {
              for (var j1 = 0; j1 < dataObj.length; j1++) {
                if (dataObj[j1].monthQuery == i1) {
                  thisData[i1] = dataObj[j1].monthLast;
                  thatData[i1] = dataObj[j1].monthThis;
                  speedData[i1] = dataObj[j1].monthThis1;
                }
              }
            }
          }
          if (now.id == 2) {
            dataObj = res.data.tmsyk;
            for (var i2 = 0; i2 < thisData.length; i2++) {
              for (var j2 = 0; j2 < dataObj.length; j2++) {
                if (dataObj[j2].monthQuery == i2) {
                  thisData[i2] = dataObj[j2].monthLast;
                  thatData[i2] = dataObj[j2].monthThis;
                  speedData[i2] = dataObj[j2].monthThis1;
                }
              }
            }
          }

          var minInNumbers = Math.min.apply(Math, speedData);
          var maxInNumbers = Math.max.apply(Math, thatData);
          var maxInNumbers1 = Math.max.apply(Math, thisData);
          var max = 0;
          var min = 0;
          var maxData =
            maxInNumbers > maxInNumbers1 ? maxInNumbers : maxInNumbers1;
          if (maxData > 250) max = maxData + 100;
          else max = 250;
          max = Math.ceil(max);
          if (minInNumbers < 0) min = -100;
          else min = 0;

          var gird = Math.ceil(max / 10);
          //产品情况
          let _this = this;
          var legendData = [];
          if (type == "0") {
            legendData = ["去年累计", "本年累计", "同比增速"];
          } else if (type == "1") {
            legendData = ["去年本月", "本月", "同比增速"];
          }
          var proEcharts = _this.$echarts.init(
            document.getElementById("proEcharts")
          );
          proEcharts.setOption(
            companyIndexPro({
              xAxis: timeArray,
              companyIndexPro: thisData,
              currentYearSall: thatData,
              proSpeed: speedData,
              legend: legendData,
              min: min,
              max: max,
              gird: gird,
              title: this.cpqk + "产品情况",
            })
          );
        });
    },
    creatEcharts() {
      var bt1 = { name: "工业总产值", id: 0 };
      if (this.proBtnList.length == 0) {
        console.log(this.proBtnList);
        var timeArray = [];
        var type = this.timeType2;
        if (type == "0") {
          timeArray = [
            "1月",
            "1-2月",
            "1-3月",
            "1-4月",
            "1-5月",
            "1-6月",
            "1-7月",
            "1-8月",
            "1-9月",
            "1-10月",
            "1-11月",
            "1-12月",
          ];
        } else if (type == "1") {
          timeArray = [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ];
        }
        var thisData = [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
        ];
        var thatData = [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
        ];
        var speedData = [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
        ];
        var legendData = [];
        if (type == "0") {
          legendData = ["去年累计", "本年累计", "同比增速"];
        } else if (type == "1") {
          legendData = ["去年本月", "本月", "同比增速"];
        }
        var proEcharts = this.$echarts.init(
          document.getElementById("proEcharts")
        );
        proEcharts.setOption(
          companyIndexPro({
            xAxis: timeArray,
            companyIndexPro: thisData,
            currentYearSall: thatData,
            proSpeed: speedData,
            legend: legendData,
            min: 0,
            max: 100,
            gird: 10,
            title: "",
          })
        );
      } else {
        var tb2 = this.proBtnList[0];
        this.changeProBtn(tb2);
      }
      this.changeSeeBtn(bt1);
    },
    myCompany() {
      let _this = this;
      var array = [];
      _this.$axios.get("/business/companyHome/selectByCode").then((res) => {
        var company = res.data;
        _this.companyName = company.name;
        //  console.log(company);
        var name = {
          name: "企业标准名称",
          code: "",
          value: company.name,
        };
        array.push(name);
        var address = {
          name: "企业办公地址",
          code: "",
          value: company.officeAddress,
        };
        array.push(address);
        var code = {
          name: "统一社会信用代码",
          code: "",
          value: company.code,
        };
        array.push(code);

        var zzjgCode = company.code;
        var subCode = "";
        if (zzjgCode.length > 9) {
          subCode = zzjgCode.substr(zzjgCode.length - 9, 9);
          //alert(zzjgCode.substr(zzjgCode.length-9, 9));
        } else {
          subCode = "";
        }

        var code1 = {
          name: "组织机构代码",
          code: "",
          value: subCode,
        };
        array.push(code1);
        var location = {
          name: "所在区（市）县",
          code: "",
          value: company.district,
        };
        array.push(location);
        var park = {
          name: "所属园区",
          code: "",
          value: company.park,
        };
        array.push(park);
        //                                         var  code2=   {
        //                                               name: "国民经济行业代码",
        //                                               code: "",
        //                                               value: company.industryType
        //                                             };array.push(code2);
        var type = {
          name: "国民经济行业分类",
          code: "",
          value: company.industryType,
        };
        array.push(type);
        var name1 = {
          name: "法人姓名",
          code: "",
          value: company.representativePerson,
        };
        array.push(name1);
        var name2 = {
          name: "联系人姓名",
          code: "",
          value: company.contactName,
        };
        array.push(name2);
        var contactPhone = {
          name: "联系人手机号码",
          code: "",
          value: company.contactPhone,
        };
        array.push(contactPhone);

        var konggu = {
          name: "企业控股情况",
          code: "",
          value: company.companyProfile,
        }; //array.push(konggu);
        var registerAddress = {
          name: "企业注册地址",
          code: "",
          value: company.registerAddress,
        };
        array.push(registerAddress);
        var registerType = {
          name: "企业登记注册类型",
          code: "",
          value: company.registerType,
        };
        array.push(registerType);
        _this.detailList = array;
      });
    },
  },
  mounted() {
    this.setTime();
    this.getNotLoadList(0, 0);
    this.getNotUpdatedList(1, 0);
    this.initPro();
    this.myCompany();
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style lang="less" scoped>
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 40px;
}
.tableList {
  display: flex;
  justify-content: space-between;
}
.part_2 {
  display: flex;
  align-items: center;
  .lineTitle {
    margin-right: 40px;
    line-height: 52px;
  }
  .lineTitle::before {
    top: 15px;
    color: #5584ff;
  }
}
.nowTitle {
  position: relative;
  padding: 10px;
  display: flex;
  align-items: center;

  margin-bottom: 10px;

  span {
    font-size: 18px;
    color: rgba(68, 68, 68, 1);
    margin-left: 30px;
    margin-top: 3px;
  }
}
@media (min-width: 1200px) {
  .card {
    width: 20%;
    margin: 0 2.5%;
  }
}

.card {
  min-height: 140px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid rgba(62, 113, 247, 1);
  border-radius: 2px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .num {
    font-size: 30px;
    color: rgba(85, 132, 255, 1);
    margin-bottom: 5px;
  }
  .label {
    font-size: 14px;
    color: rgba(68, 68, 68, 1);
  }
}
.cutData {
  display: flex;
  box-sizing: border-box;
  width: auto;
  .sinBtn {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 0;
    box-sizing: border-box;
    width: 120px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .sinBtn:last-child {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
  .sinBtn.current {
    background-color: rgba(62, 113, 247, 1);
    color: #ffffff;
  }
}
.echarts {
  margin-top: 30px;

  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 470px;
  display: flex;
  align-items: center;
  justify-content: center;
  #seeEcharts {
    width: 1500px;
    height: 450px;
  }
  #proEcharts {
    width: 1500px;
    height: 450px;
  }
}
.jumPage:hover {
  cursor: pointer;
}
.Content {
  display: flex;
  @media (max-width: 1200px) {
    .detail {
      margin-left: 0 !important;
      margin-top: 10px;
      .itemPart {
        width: 100% !important;
        height: auto !important;
        padding: 6px 0;
        border-bottom: 1px solid #cecece;
      }
    }
  }
  .detail {
    margin-left: 40px;
    display: flex;
    flex-wrap: wrap;
    .itemPart {
      width: 180px;
      height: 100px;
      box-sizing: border-box;
      display: left;
      flex-direction: column;
      justify-content: center;

      .name {
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 10px;
      }
      .value {
        font-size: 16px;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>